;
( function( $, window, document, undefined )
{
    'use strict';

    var header = function( element, options )
    {
        this.els = options.els;
        this.els.$center = this.els.$pdc6.closest('center');
        this.els.$htmlBody = $('html, body');

        this.init();
    };

    header.prototype = {

        init : function()
        {
            this.onScrollEvents();
            this.scrollToTop();
            this.contextual();
            this.search();
            this.mobile();
            this.notifications();

            if( $( '#hero-search' ).size() )
            {
                this.heroSearch();
            }
        },

        notifications: function () {
            if (!window.totalNotificationsAndMessages) {
                window.totalNotificationsAndMessages = 0;
            }

            $('#mobile-menu').attr('data-count', totalNotificationsAndMessages);
            $('#mobile-menu .mobile-menu__counter').text(totalNotificationsAndMessages);

            var $top = $('#user-notifications-menu-top')
            var loading = false

            var onClickOutside = function (e) {
                if (!$top.is(e.target) && $top.has(e.target).length === 0) {
                    $top.removeClass('active')
                }
            }

            var load = function () {
                if (loading) {
                    return
                }

                loading = true

                var $hold = $('<div />')

                $hold.load('/t5/custom/page/page-id/xhr-requests?sceeajax=true&r=notifications #notification-list', function () {
                    $('#notification-list').replaceWith($(this))
                } );
            }

            $('#alerts-button').click(function (e) {
                e.preventDefault()
                $top.toggleClass('active')

                if ($top.hasClass('active')) {
                    load()
                    common.els.$doc.on('mouseup', onClickOutside)
                } else {
                    common.els.$doc.off('mouseup', onClickOutside)
                }
            });
        },

        toggleBodyOverflow: function (toggle) {
            return;
            if (toggle && this.els.$body.hasClass('no-overflow')) {
                return;
            } else if (!toggle && !this.els.$body.hasClass('no-overflow')) {
                return;
            }

            var method   = toggle ? 'addClass' : 'removeClass',
                name     = 'no-overflow',
                position = toggle ? this.els.$win.scrollTop() : this.els.$liaPage.children().attr('style').replace(/[^0-9]/g,''),
                $target  = toggle ? this.els.$liaPage.children() : this.els.$body;

            this.els.$html[method](name);
            this.els.$body[method](name);

            if (toggle) {
                $target.css('margin-top', position * -1);
            } else {
                $target.scrollTop(position);
            }

            /*
            this.stopListeningForScroll = true;

            // var padding = this.els.$win.width() > 690 ? 64 : 0;
            var padding = 0;

            if (toggle) {
                this.previousPosition = this.els.$win.scrollTop() * -1;
            }

            this.els.$body[toggle ? 'addClass' : 'removeClass']('no-overflow');
            this.els.$center.css('margin-top', !toggle ? 0 : this.previousPosition + padding);

            if (!toggle) {
                this.els.$htmlBody.animate({scrollTop: this.previousPosition * -1}, 0);
            }
            */

            this.stopListeningForScroll = toggle;
        },

        mobile: function () {
            var $pdc6 = this.els.$pdc6;
            var $body = this.els.$body;
            var $nav = $('#right-navigation');
            var that = this;

            // only for responsive menu...
            var unread = $('#alerts-count').text()
            var messages = $('#message-alerts-count').text();
            $('#menu__counter--notifications').text(unread).attr('data-count', unread);
            $('#menu__counter--messages').text(messages).attr('data-count', messages);

            window.totalNotificationsAndMessages = parseInt(unread) + parseInt(messages);

            // hey, focus doesn't work within anonymous functions in timeouts on iOS..
            var focusSearchInput = function () {
                $('#hero-search-input').focus();
            };

            var $item = $('.menu__item');

            if (this.els.$html.hasClass('touch-device')) {
                $item.addClass('touch');
            }

            $item.find('a').on('touchstart', function (e) {
                $(this).parent().addClass('menu__item--hover').siblings().removeClass('menu__item--hover');
            }).on('touchend', function (e) {
                //$(this).parent().removeClass('menu__item--hover');
            });

            $('#mobile-menu').on('click', function (e) {
                e.preventDefault();

                $pdc6.removeClass('with-side-search with-all-topics').toggleClass('with-side-menu');
                $nav.removeClass('searching');

                if ($pdc6.hasClass('with-side-menu')) {
                    $.fn.SiteCatalyst('track', 'Hamburger open', {
                        type   : 'o',
                        vars   : {
                            prop49 : 'button:hamburger:nav:%pageName%',
                            eVar49 : 'D=c49'
                        },
                        events : [ 66 ]
                    });
                } else {
                    $.fn.SiteCatalyst('track', 'Hamburger close', {
                        type   : 'o',
                        vars   : {
                            prop49 : 'button:hamburger-close:nav:%pageName%',
                            eVar49 : 'D=c49'
                        },
                        events : [ 66 ]
                    });
                }

                that.toggleBodyOverflow($pdc6.hasClass('with-side-menu'));
            } );

            $('#mobile-search').on('click', function (e) {
                e.preventDefault();

                $pdc6.removeClass('with-side-menu with-all-topics').toggleClass('with-side-search');
                $nav.toggleClass('searching');
                that.toggleBodyOverflow($pdc6.hasClass('with-side-search'));
                if ($nav.hasClass('searching')) {
                    setTimeout(focusSearchInput, 450);

                    $.fn.SiteCatalyst('track', 'Search open', {
                        type   : 'o',
                        vars   : {
                            prop49 : 'button:search-banner:nav:%pageName%',
                            eVar49 : 'D=c49'
                        },
                        events : [ 66 ]
                    });
                } else {
                    $.fn.SiteCatalyst('track', 'Search close', {
                        type   : 'o',
                        vars   : {
                            prop49 : 'button:search-banner-close:nav:%pageName%',
                            eVar49 : 'D=c49'
                        },
                        events : [ 66 ]
                    });
                }
            } );

            $('.mobile-menu-expand').click(function (e) {
                e && e.preventDefault()

                $(this).toggleClass('active')

                var type = $(this).closest('.menu__item').index() == 0 ? 'chat-topics' : 'help-topics';
                var action = $(this).hasClass('active') ? 'open' : 'close';
                $.fn.SiteCatalyst('track', 'Side menu - Topics click', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'button:' + type + '-' + action + ':nav:%pageName%',
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                });
            });



            $('.menu__item:not(.mega) > a, .menu__board > a').click(function () {
                var $clone = $(this).clone();
                $clone.find('span').remove();
                var label = $.trim($clone.text()).toLowerCase().replace(' ', '-');
                $.fn.SiteCatalyst('track', 'Side menu - Item click', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'button:' + label + ':side-menu:%pageName%',
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                });
            });

            $('.mobile-menu-show-hide').click(function (e) {
                e && e.preventDefault()

                $(this).toggleClass('active').prev().toggleClass('active')
            })
        },

        contextual: function () {
            $('.contextual--handle').click(function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
            });
        },

        scrollToTop : function()
        {
            $( '#contextual-nav-to-top' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( !this.t )
                {
                    this.t = $( 'html, body' );
                }

                this.t.animate( {
                    scrollTop : 0
                }, 500, 'easeInCubic' );
            } );
        },

        onScrollEvents : function()
        {
            var that            = this
              , limit           = 35
              , fadeScrollLimit = 400
              , $heroCopy       = $( '#theHero .fadeItem, #topic-select' )
              , $shapeLeft      = $( '#pdc6-shape-left' )
              , $shapeRight     = $( '#pdc6-shape-right' )
              , parallaxTimeout = null;

            if( this.els.$pdc6.hasClass( 'user-contextual-nav' ) )
            {
                limit = 99;
            }

            var parallax = function()
            {
                if (that.stopListeningForScroll) {
                    return;
                }

                that.els.$pdc6[ that.els.$win.scrollTop() > limit ? 'addClass' : 'removeClass' ]( 'fixed-navigation' );

                var position = that.els.$doc.scrollTop()
                  , height   = that.els.$win.height()
                  , opacity  = (1-(position/height) *3)
                  , movement = -3-((position/height)*30);

                if( position <= fadeScrollLimit )
                {
                    $shapeLeft.css( 'margin-left', movement + '%' );
                    $shapeRight.css( 'margin-right', movement + '%' );
                }
            };

            this.els.$win.on( 'scroll', parallax );

            setTimeout( function()
            {
                that.els.$win.trigger( 'scroll' );
            }, 30 );
        },

        search : function()
        {
            var $rightNavigation = $( '#right-navigation' )
              , $userNavigation  = $( '#user-navigation' )
              , $topSearch       = $( '#top-search' )
              , $inputHolder     = $( '#search-input-holder' )
              , $input           = $( '#hero-search-input' )
              , $resultsList     = $( '#search-bar-results' )
              , template         = $( '#top-search-results-template' ).html()
              , timeout          = null
              , xhr              = null
              , completeTimer    = null
              , category         = this.els.$pdc6.data( 'top-category' )
              , endpoint         = $topSearch.data( 'location' )
              , searchURL        = '/t5/forums/searchpage/tab/message?filter=labels%2Clocation&location=category%3A' + category + '&location=category%3A' + category + '&q=';

            $resultsList.on( 'click', '.result a', function()
            {
                $.fn.SiteCatalyst( 'track', 'Nav: Search result clicked', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'search:nav:null:%pageName%',
                        eVar49 : 'D=c49',
                        prop17 : $input.val(),
                        eVar17 : 'D=c17'
                    },
                    events : [ 66, 17, 18 ]
                } );
            } );

            var openSearchPage = function( value )
            {
                $.cookie( 'search_result_trigger_events', value, { 'expires' : 352, 'path' : '/', 'domain' : window.location.hostname } );

                $.fn.SiteCatalyst( 'track', 'Nav: Show search results', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'search:nav:null:%pageName%',
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                } );

                window.location.href = searchURL + value;
            };

            var loading = function( status )
            {
                $topSearch[ status ? 'addClass' : 'removeClass' ]( 'loading' );
            };

            $( '#search-bar-show-all' ).click( function( e )
            {
                e && e.preventDefault();

                openSearchPage( $input.val() );
            } );

            var showResults = function( status )
            {
                $resultsList.find( 'li:not(#search-bar-show-all)' ).remove();
                $topSearch[ status ? 'addClass' : 'removeClass' ]( 'results' );

                if( status )
                {
                    $topSearch.addClass( 'searching' );
                }
            };

            var stop = function( clearValue )
            {
                if( null !== xhr )
                {
                    xhr.abort();
                }

                showResults( false );
                loading( false );

                if( clearValue )
                {
                    $input.val( '' );
                }
            };

            var search = function( value )
            {
                loading( true );

                if( null !== xhr )
                {
                    xhr.abort();
                }

                xhr = $.ajax( {
                    type     : 'GET',
                    url      : endpoint,
                    dataType : 'json',
                    data     : {
                        'q'          : value,
                        'categoryId' : category
                    },
                    complete : function()
                    {
                        if( null != completeTimer )
                        {
                            clearTimeout( completeTimer );
                        }

                        completeTimer = setTimeout( function()
                        {
                            loading( false );
                        }, 500 );
                    },
                    success  : function( results )
                    {
                        showResults( true );

                        if( results.length )
                        {
                            $.each( results, function( i, message )
                            {
                                if( i >= 4 )
                                {
                                    return;
                                }

                                var subject = $.fn.helpers( 'highlight', message.subject, value )
                                  , type    = message.solution ? 'solution' : 'thread';

                                var $item = $( template.replace(
                                    '%post-link%', message.href
                                ).replace(
                                    '%post-title%', subject
                                ).replace(
                                    '%post-type%', type
                                ).replace(
                                    '%post-type-info%', 'Thread: ' + message.board
                                ) );

                                $item.addClass( 'visible' ).prependTo( $resultsList );
                                //$resultsList.append( $item.addClass( 'visible' ) );
                            } );
                        }
                    },
                    error : function()
                    {
                        showResults( false );
                        //$showAll.addClass( 'hidden' );
                    }
                } );
            };

            $( '#open-search-icon' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( parseInt( $inputHolder.width() ) > 35 )
                {
                    openSearchPage( $input.val() );
                    return false;
                }

                $rightNavigation.addClass( 'searching' );

                setTimeout( function()
                {
                    $input.focus();
                    $userNavigation.addClass( 'collapsed' );
                }, 400 );
            } );

            var testTimer = null;

            $input.on( 'keyup', function( e )
            {
                if( e.which == 13 )
                {
                    openSearchPage( $( this ).val() );
                    return false;
                }

                if( null !== testTimer )
                {
                    clearTimeout( testTimer );
                }

                if( $( this ).val().length >= 3 )
                {
                    search( $( this ).val() );
                }
                else
                {
                    stop();
                }
            } );

            $( '#close-search-bar' ).on( 'click', function( e )
            {
                e && e.preventDefault();
                $userNavigation.removeClass( 'collapsed' );
                loading( false );
                showResults( false );
                $input.val( '' );

                setTimeout( function()
                {
                    $rightNavigation.removeClass( 'searching' );
                }, 100 );
            } );
        },

        heroSearch : function()
        {
            var $input        = $( '#hero-search-value' )
              , $cancel       = $( '#hero-search-reset' )
              , $trigger      = $( '#hero-search-icon' )
              , $container    = $( '#hero-search' )
              , $results      = $( '#hero-search-results' )
              , $resultsList  = $( '#hero-search-results-list' )
              , $showAll      = $( '#hero-search-all-results' )
              , template      = $( '#hero-search-results-template' ).html()
              , timeout       = null
              , xhr           = null
              , completeTimer = null
              , endpoint      = $container.data( 'location' )
              , category      = $container.data( 'category' )
              , searchURL     = '/t5/forums/searchpage/tab/message?filter=labels%2Clocation&location=category%3A' + category + '&location=category%3A' + category + '&q=';

            $resultsList.on( 'click', '.visible a', function()
            {
                $.fn.SiteCatalyst( 'track', 'Main module: Search result clicked', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'search:mainmodule:null:%pageName%',
                        eVar49 : 'D=c49',
                        prop17 : $input.val(),
                        eVar17 : 'D=c17'
                    },
                    events : [ 66, 17 ]
                } );
            } );

            var openSearchPage = function( value )
            {
                $.fn.SiteCatalyst( 'track', 'Main module: Show search results', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'search:mainmodule:null:%pageName%',
                        eVar49 : 'D=c49',
                        prop17 : value,
                        eVar17 : 'D=c17'
                    },
                    events : [ 66, 17 ]
                } );

                // console.log(searchURL + value);
                window.location.href = searchURL + value;
            };

            var loading = function( isLoading )
            {
                $container[ isLoading ? 'addClass' : 'removeClass' ]( 'loading' );
            };

            var showingResults = function( showing )
            {
                $resultsList.html( '' );
                $results[ showing ? 'addClass' : 'removeClass' ]( 'active' );
            };

            var start = function( input )
            {
                loading( true );

                if( null !== xhr )
                {
                    xhr.abort();
                }

                xhr = $.ajax( {
                    type     : 'GET',
                    url      : endpoint,
                    dataType : 'json',
                    data     : {
                        'q'          : input,
                        'categoryId' : category
                    },
                    complete : function()
                    {
                        if( null != completeTimer )
                        {
                            clearTimeout( completeTimer );
                        }

                        completeTimer = setTimeout( function()
                        {
                            loading( false );
                        }, 500 );
                    },
                    success  : function( results )
                    {
                        $showAll.removeClass( 'hidden' );
                        showingResults( true );

                        if( results.length )
                        {
                            $.each( results, function( i, message )
                            {
                                if( i >= 7)
                                {
                                    return;
                                }

                                var subject = $.fn.helpers( 'highlight', message.subject, input )
                                  , type    = message.solution ? 'solution' : 'thread';

                                var $item = $( template.replace(
                                    '%post-link%', message.href
                                ).replace(
                                    '%post-title%', subject
                                ).replace(
                                    '%post-type%', type
                                ).replace(
                                    '%post-type-info%', 'Thread: ' + message.board
                                ) );

                                $resultsList.append( $item.addClass( 'visible' ) );
                            } );
                        }
                        else
                        {
                            //$showAll.addClass( 'hidden' );
                            //showingResults( false );
                        }
                    },
                    error : function()
                    {
                        showingResults( false );
                        $showAll.addClass( 'hidden' );
                    }
                } );
            };

            var stop = function( clearValue )
            {
                // clearTimeout( timeout );
                showingResults( false );
                loading( false );

                if( clearValue )
                {
                    $input.val( '' );
                }
            };

            $showAll.on( 'click', function( e )
            {
                e && e.preventDefault;

                openSearchPage( $input.val() );
            } );

            $input.on( 'keyup', function( e )
            {
                if( e.which == 13 )
                {
                    openSearchPage( $( this ).val() );
                    return false;
                }

                var val = $( this ).val()
                  , l   = val.length;

                $cancel[ l > 0 ? 'addClass' : 'removeClass' ]( 'enabled' );

                if( l >= 3 )
                {
                    start( val );
                }
                else
                {
                    stop();
                }
            } );

            $trigger.on( 'click', function( e )
            {
                e && e.preventDefault();

                if( $input.val().length >= 3 )
                {
                    openSearchPage( $input.val() );
                }
            } );

            $cancel.on( 'click', function( e )
            {
                e && e.preventDefault();

                if( !$( this ).hasClass( 'enabled' ) )
                {
                    return false;
                }

                stop( true );

                $( this ).removeClass( 'enabled' );
            } );
        }

    };

    $.fn.header = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'header' );

        if( !instance )
        {
            instance = new header( this, options );
            $item.data( 'header', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
